import React from 'react';
import { Card, CardContent, Typography, Box, Avatar } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { 
  Business as BusinessIcon
} from '@mui/icons-material';
import FollowButton from 'components/common/buttons/FollowButton';

const StyledCard = styled(Card)(({ theme, selected }) => ({
  height: '100%',
  width: '100%',
  minWidth: 0,
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  position: 'relative',
  // border: selected ? `1px solid ${theme.palette.primary.light}` : '1px solid #e0e0e0',
  // backgroundColor: '#eeeeeeff',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
    border: '1px solid #e0e0e0',
  },
  '& .MuiCardContent-root': {
    padding: '12px',
    '&:last-child': {
      paddingBottom: '12px'
    }
  }
}));

const OrganizationCard = ({ 
  organization, 
  isSelected, 
  onSelect,
  onNavigate
}) => {
  const theme = useTheme();
  return (
    <StyledCard selected={isSelected}  onClick={(e) => {
      e.stopPropagation();
      onNavigate(`/organization/${organization.id}`);
    }}>
      <CardContent sx={{ cursor: 'pointer' }} >
        {/* {isSelected && (
          <CheckCircleIcon 
            color="primary" 
            sx={{ position: 'absolute', top: 8, right: 8, fontSize: 20 }} 
          />
        )}
         */}
        <Box display="flex" alignItems="center" mb={1}>
          <Avatar 
            src={organization.logo} 
            sx={{ width: 44, height: 44, mr: 1.5, fontSize: '1.5rem',
              backgroundColor: theme.palette.primary.avatar,
              color: 'white',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
              // border: `1px solid ${theme.palette.sidebar.active}`,
              mb: 0.5,
              mt: 0.5
             }}
          >
            <BusinessIcon />
          </Avatar>



          <Box flex={1}>
            <Typography 
              variant="subtitle1"
              sx={{ 
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: '1.3rem',
                lineHeight: 1.4,
                '&:hover': { textDecoration: 'underline' }
              }}
              onClick={(e) => {
                e.stopPropagation();
                onNavigate(`/organization/${organization.id}`);
              }}
            >
              {organization.name}
            </Typography>
            {organization.org_type && (
              <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
                {organization.org_type.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
              </Typography>
            )}
            {organization.address?.country?.name && (
              <Typography variant="caption" color="text.secondary" display="block" sx={{ fontSize: '0.7rem', mt: 0.25 }}>
                📍 {organization.address.city ? `${organization.address.city}, ` : ''}{organization.address.country.name}
              </Typography>
            )}
          </Box>
        </Box>

        {organization.description && (
          <Typography 
            variant="body2" 
            color="text.secondary" 
            sx={{ 
              mb: 0.5,
              fontSize: '0.8rem',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              lineHeight: 1.3
            }}
          >
            {organization.description}
          </Typography>
        )}

        {/* Follow Button */}
        <Box 
          sx={{ 
            mt: 1, 
            pt: 1, 
            borderTop: '1px solid', 
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'left'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <FollowButton
            contentType="organization"
            objectId={organization.id}
            size="small"
            variant="outlined"
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default OrganizationCard;
